import CodeMirror from 'codemirror'
import type {Editor} from 'codemirror'

const loading: {[key: string]: Callback[]} = {}

// Maps all supported CodeMirror v5 modes to their module URLs so Webpack can manage and fingerprint them instead of relying on static assets
const MODE_IMPORTS: Record<string, string> = {
  apl: new URL('codemirror/mode/apl/apl.js', import.meta.url).toString(),
  asciiarmor: new URL('codemirror/mode/asciiarmor/asciiarmor.js', import.meta.url).toString(),
  'asn.1': new URL('codemirror/mode/asn.1/asn.1.js', import.meta.url).toString(),
  asterisk: new URL('codemirror/mode/asterisk/asterisk.js', import.meta.url).toString(),
  brainfuck: new URL('codemirror/mode/brainfuck/brainfuck.js', import.meta.url).toString(),
  clike: new URL('codemirror/mode/clike/clike.js', import.meta.url).toString(),
  clojure: new URL('codemirror/mode/clojure/clojure.js', import.meta.url).toString(),
  cmake: new URL('codemirror/mode/cmake/cmake.js', import.meta.url).toString(),
  cobol: new URL('codemirror/mode/cobol/cobol.js', import.meta.url).toString(),
  coffeescript: new URL('codemirror/mode/coffeescript/coffeescript.js', import.meta.url).toString(),
  commonlisp: new URL('codemirror/mode/commonlisp/commonlisp.js', import.meta.url).toString(),
  crystal: new URL('codemirror/mode/crystal/crystal.js', import.meta.url).toString(),
  css: new URL('codemirror/mode/css/css.js', import.meta.url).toString(),
  cypher: new URL('codemirror/mode/cypher/cypher.js', import.meta.url).toString(),
  d: new URL('codemirror/mode/d/d.js', import.meta.url).toString(),
  dart: new URL('codemirror/mode/dart/dart.js', import.meta.url).toString(),
  diff: new URL('codemirror/mode/diff/diff.js', import.meta.url).toString(),
  django: new URL('codemirror/mode/django/django.js', import.meta.url).toString(),
  dockerfile: new URL('codemirror/mode/dockerfile/dockerfile.js', import.meta.url).toString(),
  dtd: new URL('codemirror/mode/dtd/dtd.js', import.meta.url).toString(),
  dylan: new URL('codemirror/mode/dylan/dylan.js', import.meta.url).toString(),
  ebnf: new URL('codemirror/mode/ebnf/ebnf.js', import.meta.url).toString(),
  ecl: new URL('codemirror/mode/ecl/ecl.js', import.meta.url).toString(),
  eiffel: new URL('codemirror/mode/eiffel/eiffel.js', import.meta.url).toString(),
  elm: new URL('codemirror/mode/elm/elm.js', import.meta.url).toString(),
  erlang: new URL('codemirror/mode/erlang/erlang.js', import.meta.url).toString(),
  factor: new URL('codemirror/mode/factor/factor.js', import.meta.url).toString(),
  fcl: new URL('codemirror/mode/fcl/fcl.js', import.meta.url).toString(),
  forth: new URL('codemirror/mode/forth/forth.js', import.meta.url).toString(),
  fortran: new URL('codemirror/mode/fortran/fortran.js', import.meta.url).toString(),
  gas: new URL('codemirror/mode/gas/gas.js', import.meta.url).toString(),
  gfm: new URL('codemirror/mode/gfm/gfm.js', import.meta.url).toString(),
  gherkin: new URL('codemirror/mode/gherkin/gherkin.js', import.meta.url).toString(),
  go: new URL('codemirror/mode/go/go.js', import.meta.url).toString(),
  groovy: new URL('codemirror/mode/groovy/groovy.js', import.meta.url).toString(),
  haml: new URL('codemirror/mode/haml/haml.js', import.meta.url).toString(),
  handlebars: new URL('codemirror/mode/handlebars/handlebars.js', import.meta.url).toString(),
  haskell: new URL('codemirror/mode/haskell/haskell.js', import.meta.url).toString(),
  'haskell-literate': new URL('codemirror/mode/haskell-literate/haskell-literate.js', import.meta.url).toString(),
  haxe: new URL('codemirror/mode/haxe/haxe.js', import.meta.url).toString(),
  htmlembedded: new URL('codemirror/mode/htmlembedded/htmlembedded.js', import.meta.url).toString(),
  htmlmixed: new URL('codemirror/mode/htmlmixed/htmlmixed.js', import.meta.url).toString(),
  http: new URL('codemirror/mode/http/http.js', import.meta.url).toString(),
  idl: new URL('codemirror/mode/idl/idl.js', import.meta.url).toString(),
  javascript: new URL('codemirror/mode/javascript/javascript.js', import.meta.url).toString(),
  jinja2: new URL('codemirror/mode/jinja2/jinja2.js', import.meta.url).toString(),
  jsx: new URL('codemirror/mode/jsx/jsx.js', import.meta.url).toString(),
  julia: new URL('codemirror/mode/julia/julia.js', import.meta.url).toString(),
  livescript: new URL('codemirror/mode/livescript/livescript.js', import.meta.url).toString(),
  lua: new URL('codemirror/mode/lua/lua.js', import.meta.url).toString(),
  markdown: new URL('codemirror/mode/markdown/markdown.js', import.meta.url).toString(),
  mathematica: new URL('codemirror/mode/mathematica/mathematica.js', import.meta.url).toString(),
  mbox: new URL('codemirror/mode/mbox/mbox.js', import.meta.url).toString(),
  mirc: new URL('codemirror/mode/mirc/mirc.js', import.meta.url).toString(),
  mllike: new URL('codemirror/mode/mllike/mllike.js', import.meta.url).toString(),
  modelica: new URL('codemirror/mode/modelica/modelica.js', import.meta.url).toString(),
  mscgen: new URL('codemirror/mode/mscgen/mscgen.js', import.meta.url).toString(),
  mumps: new URL('codemirror/mode/mumps/mumps.js', import.meta.url).toString(),
  nginx: new URL('codemirror/mode/nginx/nginx.js', import.meta.url).toString(),
  nsis: new URL('codemirror/mode/nsis/nsis.js', import.meta.url).toString(),
  ntriples: new URL('codemirror/mode/ntriples/ntriples.js', import.meta.url).toString(),
  octave: new URL('codemirror/mode/octave/octave.js', import.meta.url).toString(),
  oz: new URL('codemirror/mode/oz/oz.js', import.meta.url).toString(),
  pascal: new URL('codemirror/mode/pascal/pascal.js', import.meta.url).toString(),
  pegjs: new URL('codemirror/mode/pegjs/pegjs.js', import.meta.url).toString(),
  perl: new URL('codemirror/mode/perl/perl.js', import.meta.url).toString(),
  php: new URL('codemirror/mode/php/php.js', import.meta.url).toString(),
  pig: new URL('codemirror/mode/pig/pig.js', import.meta.url).toString(),
  powershell: new URL('codemirror/mode/powershell/powershell.js', import.meta.url).toString(),
  properties: new URL('codemirror/mode/properties/properties.js', import.meta.url).toString(),
  protobuf: new URL('codemirror/mode/protobuf/protobuf.js', import.meta.url).toString(),
  pug: new URL('codemirror/mode/pug/pug.js', import.meta.url).toString(),
  puppet: new URL('codemirror/mode/puppet/puppet.js', import.meta.url).toString(),
  python: new URL('codemirror/mode/python/python.js', import.meta.url).toString(),
  q: new URL('codemirror/mode/q/q.js', import.meta.url).toString(),
  r: new URL('codemirror/mode/r/r.js', import.meta.url).toString(),
  rpm: new URL('codemirror/mode/rpm/rpm.js', import.meta.url).toString(),
  rst: new URL('codemirror/mode/rst/rst.js', import.meta.url).toString(),
  ruby: new URL('codemirror/mode/ruby/ruby.js', import.meta.url).toString(),
  rust: new URL('codemirror/mode/rust/rust.js', import.meta.url).toString(),
  sas: new URL('codemirror/mode/sas/sas.js', import.meta.url).toString(),
  sass: new URL('codemirror/mode/sass/sass.js', import.meta.url).toString(),
  scheme: new URL('codemirror/mode/scheme/scheme.js', import.meta.url).toString(),
  shell: new URL('codemirror/mode/shell/shell.js', import.meta.url).toString(),
  sieve: new URL('codemirror/mode/sieve/sieve.js', import.meta.url).toString(),
  slim: new URL('codemirror/mode/slim/slim.js', import.meta.url).toString(),
  smalltalk: new URL('codemirror/mode/smalltalk/smalltalk.js', import.meta.url).toString(),
  smarty: new URL('codemirror/mode/smarty/smarty.js', import.meta.url).toString(),
  solr: new URL('codemirror/mode/solr/solr.js', import.meta.url).toString(),
  soy: new URL('codemirror/mode/soy/soy.js', import.meta.url).toString(),
  sparql: new URL('codemirror/mode/sparql/sparql.js', import.meta.url).toString(),
  spreadsheet: new URL('codemirror/mode/spreadsheet/spreadsheet.js', import.meta.url).toString(),
  sql: new URL('codemirror/mode/sql/sql.js', import.meta.url).toString(),
  stex: new URL('codemirror/mode/stex/stex.js', import.meta.url).toString(),
  stylus: new URL('codemirror/mode/stylus/stylus.js', import.meta.url).toString(),
  swift: new URL('codemirror/mode/swift/swift.js', import.meta.url).toString(),
  tcl: new URL('codemirror/mode/tcl/tcl.js', import.meta.url).toString(),
  textile: new URL('codemirror/mode/textile/textile.js', import.meta.url).toString(),
  tiddlywiki: new URL('codemirror/mode/tiddlywiki/tiddlywiki.js', import.meta.url).toString(),
  tiki: new URL('codemirror/mode/tiki/tiki.js', import.meta.url).toString(),
  toml: new URL('codemirror/mode/toml/toml.js', import.meta.url).toString(),
  tornado: new URL('codemirror/mode/tornado/tornado.js', import.meta.url).toString(),
  troff: new URL('codemirror/mode/troff/troff.js', import.meta.url).toString(),
  ttcn: new URL('codemirror/mode/ttcn/ttcn.js', import.meta.url).toString(),
  'ttcn-cfg': new URL('codemirror/mode/ttcn-cfg/ttcn-cfg.js', import.meta.url).toString(),
  turtle: new URL('codemirror/mode/turtle/turtle.js', import.meta.url).toString(),
  twig: new URL('codemirror/mode/twig/twig.js', import.meta.url).toString(),
  vb: new URL('codemirror/mode/vb/vb.js', import.meta.url).toString(),
  vbscript: new URL('codemirror/mode/vbscript/vbscript.js', import.meta.url).toString(),
  velocity: new URL('codemirror/mode/velocity/velocity.js', import.meta.url).toString(),
  verilog: new URL('codemirror/mode/verilog/verilog.js', import.meta.url).toString(),
  vhdl: new URL('codemirror/mode/vhdl/vhdl.js', import.meta.url).toString(),
  vue: new URL('codemirror/mode/vue/vue.js', import.meta.url).toString(),
  wast: new URL('codemirror/mode/wast/wast.js', import.meta.url).toString(),
  webidl: new URL('codemirror/mode/webidl/webidl.js', import.meta.url).toString(),
  xml: new URL('codemirror/mode/xml/xml.js', import.meta.url).toString(),
  xquery: new URL('codemirror/mode/xquery/xquery.js', import.meta.url).toString(),
  yacas: new URL('codemirror/mode/yacas/yacas.js', import.meta.url).toString(),
  yaml: new URL('codemirror/mode/yaml/yaml.js', import.meta.url).toString(),
  'yaml-frontmatter': new URL('codemirror/mode/yaml-frontmatter/yaml-frontmatter.js', import.meta.url).toString(),
  z80: new URL('codemirror/mode/z80/z80.js', import.meta.url).toString(),
}

type Callback = () => void

function splitCallback(cont: Callback, n: number): Callback {
  let countDown = n
  return () => {
    if (--countDown === 0) {
      cont()
    }
  }
}

function ensureDeps(mode: string, cont: Callback) {
  // @ts-expect-error dependencies doesn't exist on mode?
  const deps = CodeMirror.modes[mode].dependencies
  if (!deps) {
    return cont()
  }

  const missing = []
  for (let i = 0; i < deps.length; ++i) {
    if (!CodeMirror.modes.hasOwnProperty(deps[i])) {
      missing.push(deps[i])
    }
  }
  if (!missing.length) {
    return cont()
  }

  const split = splitCallback(cont, missing.length)
  for (let i = 0; i < missing.length; ++i) {
    CodeMirror.requireMode(missing[i], split)
  }
}

export function requireMode(mode: string, cont: Callback) {
  if (CodeMirror.modes.hasOwnProperty(mode)) {
    return ensureDeps(mode, cont)
  }
  if (loading.hasOwnProperty(mode)) {
    return loading[mode]!.push(cont)
  }

  const file = MODE_IMPORTS[mode]

  if (!file) {
    throw new Error(`CodeMirror mode "${mode}" not found.`)
  }

  // XXX: Export CodeMirror global for lazy load dep to attach to
  window.CodeMirror = CodeMirror

  // eslint-disable-next-line github/no-dynamic-script-tag
  const script = document.createElement('script')
  script.src = file

  script.crossOrigin = 'anonymous'
  const metaElement = document.querySelector('meta[name=codemirror-crossorigin-credentials]')
  if (metaElement) {
    script.crossOrigin = 'use-credentials'
  }

  const others = document.getElementsByTagName('script')[0]!
  const list = (loading[mode] = [cont])
  CodeMirror.on(script, 'load', () => {
    ensureDeps(mode, () => {
      for (let i = 0; i < list.length; ++i) {
        list[i]!()
      }
    })
  })

  if (others.parentNode == null) {
    throw new Error('first script node must be in the document.')
  }

  others.parentNode.insertBefore(script, others)
}

export function autoLoadMode(instance: Editor, mode: string) {
  if (!CodeMirror.modes.hasOwnProperty(mode)) {
    CodeMirror.requireMode(mode, () => {
      instance.setOption('mode', instance.getOption('mode'))
    })
  }
}
